import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

type OfferDefinitionsProps = {
  trendsTab?: boolean;
};

const OfferDefinitions = ({ trendsTab = false }: OfferDefinitionsProps) => {
  const { t } = useTranslation();

  const offerDefinitions = [
    apiDefinitions.loyaltyOfferName,
    apiDefinitions.currentStatus,
    apiDefinitions.offerType,
    apiDefinitions.distributionMethod,
    apiDefinitions.redemptionDateRange,
    apiDefinitions.distributionDateRange,
    apiDefinitions.averageDaysToRedeem,
    apiDefinitions.redemptionsAllTimeDistributions,
    apiDefinitions.redemptionsSelectedTimePeriodDistributions,
    trendsTab ? undefined : apiDefinitions.redemptionRateAllTime,
    apiDefinitions.redemptionRateDistributedAndRedeemedInPeriod,
    apiDefinitions.redemptionRateDistributedAllTimeRedeemedInPeriod,
    apiDefinitions.distributionsSelectedTimePeriod,
    apiDefinitions.totalOpened,
    apiDefinitions.totalDeleted,
    apiDefinitions.totalSaved,
  ].filter(Boolean);

  return (
    <APIDefinitions
      definitions={offerDefinitions}
      type={t('page.loyaltyPerformanceReport.apiDefinitionTitles.offer.label')}
    />
  );
};

export default OfferDefinitions;
